// src/index.ts
import { mergeConfigs } from "tailwind-merge";
function withFluid(config) {
  if (config.prefix)
    throw new Error(`@fluid-tailwind/tailwind-merge doesn't work with custom prefixes`);
  const isThemeGetter = (def) => typeof def === "function" && "isThemeGetter" in def && def.isThemeGetter;
  const buildFluidValidator = (defs) => (val) => {
    const parts = val.split("/");
    return parts.length === 2 && defs.length > 0 && parts.every((v) => defs.some((d) => typeof d === "string" ? d === v : d(v)));
  };
  const resolveThemeGetters = (group) => group.flatMap((def) => isThemeGetter(def) ? resolveThemeGetters(def(config.theme)) : [def]);
  const fluidizeClassGroup = (group, toplevel = false) => {
    const objDefs = [];
    const nonObjDefs = [];
    resolveThemeGetters(group).forEach((def) => {
      if (typeof def !== "object") return !toplevel && nonObjDefs.push(def);
      objDefs.push(
        Object.fromEntries(
          Object.entries(def).flatMap(([name, defs]) => {
            const newDefs = fluidizeClassGroup(defs);
            return toplevel ? [
              [`~${name}`, newDefs],
              [`~-${name}`, newDefs]
            ] : [[name, newDefs]];
          })
        )
      );
    });
    return [buildFluidValidator(nonObjDefs), ...objDefs];
  };
  const classGroups = Object.fromEntries(
    Object.entries(config.classGroups).map(([name, group]) => {
      return [name, fluidizeClassGroup(group, true).slice(1)];
    })
  );
  return mergeConfigs(config, {
    extend: {
      classGroups
    },
    experimentalParseClassName({ className, parseClassName }) {
      const parsed = parseClassName(className);
      return {
        ...parsed,
        modifiers: parsed.modifiers.filter((modifier) => !modifier.startsWith("~"))
      };
    }
  });
}
export {
  withFluid
};
